// @flow

import styled from 'styled-components'
import Colors from 'styles/colors'
import { zIndexes } from 'frontend_core/dist/styles/variables'

const LoadingView = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  opacity: 0.3;
  background-color: ${Colors.white};
  z-index: ${zIndexes.nav};
`

export default LoadingView
